import { render, staticRenderFns } from "./index.page.vue?vue&type=template&id=a95b1da6&scoped=true&"
import script from "./index.page.vue?vue&type=script&lang=js&"
export * from "./index.page.vue?vue&type=script&lang=js&"
import style0 from "./index.page.vue?vue&type=style&index=0&id=a95b1da6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a95b1da6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\mzkj\\要炼\\yl-pc-business\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a95b1da6')) {
      api.createRecord('a95b1da6', component.options)
    } else {
      api.reload('a95b1da6', component.options)
    }
    module.hot.accept("./index.page.vue?vue&type=template&id=a95b1da6&scoped=true&", function () {
      api.rerender('a95b1da6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/afterSale/exchangeGoods/index.page.vue"
export default component.exports